<div class="dialog-container">
  <h2 mat-dialog-title>Re-Open</h2>

  <mat-dialog-content>
    <div class="project-info">
      <span class="project-value">{{ projectId }}</span>
    </div>

    <div class="form-fields">
      <mat-form-field class="full-width">
        <mat-label>Reason for Re-opening</mat-label>
        <mat-select [formControl]="reasonControl" required>
          @for (option of reasonOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
        @if (reasonControl.hasError('required')) {
          <mat-error>Reason is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Reason for Re-opening (Other)</mat-label>
        <input matInput [formControl]="reasonOtherControl" placeholder="Enter other reason" />
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="confirmReopen()">Save</button>
    <button mat-button (click)="closeDialog()">Cancel</button>
  </mat-dialog-actions>
</div>
